import { render, staticRenderFns } from "./ContactImportDialog.vue?vue&type=template&id=54dc4774&scoped=true"
import script from "./ContactImportDialog.vue?vue&type=script&lang=js"
export * from "./ContactImportDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactImportDialog.vue?vue&type=style&index=0&id=54dc4774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc4774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
